import PageHeader from "@/components/PageHeader";
import ListSection from "@/components/ListSection";

const CATEGORIES = ["Tekniska", "Administrativa", "Praktiska", "Kundservice", "Ledarskap", "Problemlösning", "Språk", "Certifikat", "Andra färdigheter"];
const LEVELS = ["Grundläggande", "Van", "Erfaren", "Expert"];

const FIELDS = [
  { name: "name", label: "Kompetens", type: "text", placeholder: "T.ex. Lagerhantering" },
  { name: "category", label: "Kategori", type: "select", options: CATEGORIES },
  { name: "level", label: "Självskattad nivå", type: "select", options: LEVELS },
  { name: "used_where", label: "Var kompetensen har använts", type: "textarea", full: true },
  { name: "evidence", label: "Exempel eller bevis", type: "textarea", full: true },
];

export default function Kompetenser() {
  return (
    <div>
      <PageHeader title="Kompetenser" description="Samla och kategorisera dina kompetenser. Ange gärna var du använt dem och exempel som styrker dem." />
      <ListSection
        endpoint="skills"
        fields={FIELDS}
        addLabel="Lägg till kompetens"
        emptyText="Inga kompetenser tillagda ännu."
        ai={{
          section: "skills",
          title: "AI-hjälp med dina kompetenser",
          intro: "Jag hjälper dig hitta och formulera kompetenser utifrån din erfarenhet – du godkänner varje tillägg.",
          suggestions: [
            "Vilka kompetenser har jag utifrån min erfarenhet?",
            "Hjälp mig sätta ord på mina praktiska färdigheter",
            "Vad kan jag lägga till om jag jobbat i lager?",
          ],
          mapProposal: (p) => ({
            name: p.value?.name || "",
            category: p.value?.category || "Andra färdigheter",
            level: p.value?.level || "",
            used_where: p.value?.used_where || "",
          }),
        }}
        summary={(it) => ({
          title: it.name,
          subtitle: it.category,
          meta: it.level ? `Nivå: ${it.level}` : "",
          body: it.used_where,
        })}
      />
    </div>
  );
}
